<section class="flex register-profesori container">
  <main>
    <div class="modal-header">
      <h3 class="modal-title">{{ 'general.register_educator' | translate }}</h3>
      <button type="button" class="close-btn" (click)="closeModal()">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <form [formGroup]="professorRegister">
      <!-- Full Name -->
      <h5>{{ 'general.full_name' | translate }}</h5>
      <input formControlName="professorName" type="text" />
      <div *ngIf="
               professorRegister.controls.professorName.touched &&
               professorRegister.controls.professorName.invalid
            " class="invalid">
        {{ 'general.full_name' | translate }} {{ 'aria-labels.is_required' | translate }}
      </div>
      <div *ngIf="
               professorRegister.controls.professorName.errors?.minlength
            " class="invalid">
        {{ 'general.full_name' | translate }} {{ 'aria-labels.should_contain_at_least_3_characters' | translate }}.
      </div>

      <!-- Institution -->
      <h5>{{ 'app.institution' | translate }}</h5>
      <select formControlName="professorFaculty" (change)="facultyChanged()">
        <option selected disabled value="">{{ 'general.select_institution' | translate }}</option>
        <ng-container *ngFor="let faculty of this.faculties">
          <option value="{{ faculty.id }}">
            {{ faculty.name }}
          </option>
        </ng-container>
      </select>
      <div *ngIf="
               professorRegister.controls.professorFaculty.touched &&
               professorRegister.controls.professorFaculty.invalid
            " class="invalid">
        {{ 'general.educator' | translate }} {{ 'app.institution' | translate }} {{ 'aria-labels.is_required' |
        translate }}*
      </div>

      <!-- Department -->
      <h5>{{ 'general.department' | translate }}</h5>
      <select disabled *ngIf="
               professorRegister.controls.professorFaculty.value == '' ||
               professorRegister.controls.professorFaculty == undefined
            " name="" id="">
        <option value="">{{ 'general.select_institution_first' | translate }}</option>
      </select>
      <select *ngIf="
               professorRegister.controls.professorFaculty.value !== '' &&
               professorRegister.controls.professorFaculty !== undefined
            " formControlName="professorDepartment" (change)="departmentChanged()">
        <option selected disabled value="">{{ 'general.select_department' | translate }}</option>
        <ng-container *ngFor="let department of this.departments">
          <option value="{{ department.id }}">
            {{ department.name }}
          </option>
        </ng-container>
      </select>
      <div *ngIf="
               professorRegister.controls.professorDepartment.touched &&
               professorRegister.controls.professorDepartment.invalid
            " class="invalid">
        {{ 'general.educator' | translate }} {{ 'general.department' | translate }} {{ 'aria-labels.is_required' |
        translate }}*
      </div>

      <!-- Subject -->
      <h5>{{ 'general.subject' | translate }}</h5>
      <select disabled *ngIf="
               professorRegister.controls.professorDepartment.value == '' ||
               professorRegister.controls.professorDepartment == undefined
            " name="" id="">
        <option value="">{{ 'general.select_subject_first' | translate }}</option>
      </select>
      <select *ngIf="
               professorRegister.controls.professorDepartment.value !== '' &&
               professorRegister.controls.professorDepartment !== undefined
            " formControlName="professorCourse">
        <option selected value="">{{ 'general.select_subject' | translate }}</option>
        <ng-container *ngFor="let course of this.courses">
          <option value="{{ course.id }}">
            {{ course.title }}
          </option>
        </ng-container>
      </select>


      <!-- Email -->
      <h5 class="emailAddress">{{ 'general.email' | translate }}</h5>
      <input formControlName="professorEmail" type="email" />
      <!-- <div *ngIf="this.emailExists" class="invalid">
            Email already exists, please try another one.*
         </div> -->
      <div *ngIf="
               professorRegister.controls.professorEmail.touched &&
               professorRegister.controls.professorEmail.invalid
            " class="invalid">
        {{ 'general.educator' | translate }} {{ 'login.email_required' | translate }}*
      </div>
      <div *ngIf="professorRegister.controls.professorEmail.errors?.email" class="invalid">
        {{ 'app.educator_email_is_not_valid' | translate }}*
      </div>

      <!-- Educator Index ID -->
      <h5>{{ 'general.educator_index_id' | translate }}</h5>
      <input formControlName="uniqueIdentifier" type="text"
        placeholder="{{ 'general.unique_identifier_placeholder' | translate }}" />
      <div class="modal-actions">
        <button type="button" class="btn-secondary-md" (click)="closeModal()">
          {{ 'general.cancel' | translate }}
        </button>
        <button [disabled]="professorRegister.invalid || this.emailExists" [ngClass]="{
                  disable: professorRegister.invalid || this.emailExists
               }" class="btn-blue-filled-md" type="submit" (click)="submit()">
          {{ 'app.confirm' | translate }}
        </button>
      </div>
    </form>
  </main>
</section>